module.exports = __webpack_public_path__ + "contract_icon.bf674412c053ec688ed736d31b746bbb.svg";